import React, { useState } from 'react'
import { CustomDialog, CustomTabs, NormalSwitch } from '../../../components/StyledComponents'
import { DialogActions, DialogContent, DialogTitle, Tab } from '@mui/material'
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, ControlpanelWarningButton, GrayIconButton } from '../../../components/StyledButton'
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { PropTypes } from 'prop-types';
import ReplayIcon from '@mui/icons-material/Replay';

const SettingUserGroupDialog = (props) => {
    const { t } = useTranslation()

    const [tabValue, setTabValue] = useState(0);

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const CustomTabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`user-specific-tabpanel-${index}`}
                aria-labelledby={`user-specific-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <div className='mt-3'>
                        {children}
                    </div>
                )}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    const a11yProps = (index) => {
        return {
            id: `group-specific-settings-tab-${index}`,
            'aria-controls': `group-specific-settings-tabpanel-${index}`,
        };
    }

    const [checked, setChecked] = useState(false);

    const handleSwitchChange = (event) => {
        setChecked(event.target.checked);
    };

    return (
        <CustomDialog
            transitionDuration={300}
            maxWidth={"xl"}
            open={props.open}
            onClose={props.handleClose}
            keepMounted
        >

            <DialogTitle>
                <div className='flex justify-between'>
                    <div className='flex items-center gap-4'>
                        <p className='text-xl font-semibold '>Group specific settings</p>
                    </div>
                    <GrayIconButton onClick={props.handleClose}>
                        <CloseIcon />
                    </GrayIconButton>
                </div>
            </DialogTitle>

            <DialogContent>
                <div className='h-[1px] bg-[#E7E7E7] w-full my-3'></div>
                <div className='tab'>
                    <CustomTabs
                        // variant="fullWidth"
                        indicatorColor='none'
                        value={tabValue}
                        onChange={handleChangeTab}>
                        <Tab label={
                            <div className='flex flex-col md:flex-row items-center gap-1'>
                                <p className='text-sm'>{t('common.general')}</p>
                            </div>
                        }
                            {...a11yProps(0)}
                            disableRipple

                        />

                    </CustomTabs>
                    <CustomTabPanel value={tabValue} index={0}>
                        <div className='grid grid-cols-12 items-center'>
                            <div className='col-span-7'>
                                <p>{t('common.maximum-occupancy-for-group-premises')}</p>
                            </div>
                            <div className='col-span-5 '>
                                <div className='flex items-center gap-5 justify-end'>
                                    <NormalSwitch checked={checked} onChange={handleSwitchChange} />
                                    <ControlpanelWarningButton>
                                        <ReplayIcon />
                                    </ControlpanelWarningButton>
                                </div>
                            </div>
                        </div>
                        {checked
                            ?
                            <div className='grid grid-cols-12 items-center pt-5'>
                                <div className='col-span-7'>
                                    <p>{t('common.maximum-number-of-users-that-can-be-working-at-a-time')}</p>
                                </div>
                                <div className='col-span-5 '>
                                    <div className='flex items-center gap-5 justify-end'>
                                        <input type="number" className='outline-none border border-solid border-[#E5E7EB] py-2 px-3 rounded-md' value={props.users.length} />
                                    </div>
                                </div>
                            </div>
                            :
                            <></>
                        }
                    </CustomTabPanel>
                </div>
            </DialogContent>

            <DialogActions>
                <div className='flex gap-2 px-4 py-4'>
                    <ControlpanelSecondaryButton onClick={props.handleClose}>
                        <CloseIcon />
                        <p>{t('button.close')}</p>
                    </ControlpanelSecondaryButton>

                </div>
            </DialogActions>
        </CustomDialog>
    )
}

export default SettingUserGroupDialog